import React from 'react'
import PropTypes from 'prop-types'

const CompositionsListGenreItem = ({
  clickGenreHandler,
  genreId,
  image,
  selected,
  title,
  index,
  genresRef,
}) => (
  <li className="composition_list_item">
    <button
      className={`composition_block composition_block_btn genres_mod ${
        selected && 'genre_selected'
      }`}
      ref={(btn) => (genresRef.current[index] = btn)}
      {...(!selected && { onClick: () => clickGenreHandler(genreId) })}
    >
      <div className="composition_block_w_img">
        <img className="composition_block_img" src={image} alt={title} />
      </div>
      <div className="composition_block_descr">
        <span className="composition_block_title default_text">{title}</span>
      </div>
    </button>
  </li>
)

export default CompositionsListGenreItem

CompositionsListGenreItem.propTypes = {
  clickGenreHandler: PropTypes.func.isRequired,
  genreId: PropTypes.string.isRequired,
  image: PropTypes.string,
  selected: PropTypes.bool,
  title: PropTypes.string.isRequired,
}
